/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BusinessExceptionResponse = {
    code?: BusinessExceptionResponse.code;
    description?: string;
};
export namespace BusinessExceptionResponse {
    export enum code {
        ACCESS_DENIED = 'ACCESS_DENIED',
        API_CALL_ERROR = 'API_CALL_ERROR',
        CATEGORY_HAS_PRODUCT = 'CATEGORY_HAS_PRODUCT',
        CATEGORY_NOT_FOUND = 'CATEGORY_NOT_FOUND',
        CHECK_IMEI_FAILURE = 'CHECK_IMEI_FAILURE',
        CHECK_IMEI_SERVICE_NOT_FOUND = 'CHECK_IMEI_SERVICE_NOT_FOUND',
        COMMISSION_INCORRECT = 'COMMISSION_INCORRECT',
        CUSTOMER_NOT_FOUND = 'CUSTOMER_NOT_FOUND',
        DEVICE_CASE_IMAGE_MISSING = 'DEVICE_CASE_IMAGE_MISSING',
        DEVICE_MANAGEMENT_KEY_NOT_FOUND = 'DEVICE_MANAGEMENT_KEY_NOT_FOUND',
        DEVICE_NOT_FOUND = 'DEVICE_NOT_FOUND',
        DEVICE_NOT_REGISTERED = 'DEVICE_NOT_REGISTERED',
        DEVICE_UNLOCK_FAILED = 'DEVICE_UNLOCK_FAILED',
        DEVICE_CASE_NOT_FOUND = 'DEVICE_CASE_NOT_FOUND',
        DUPLICATE_FINE_THRESHOLD_OVERDUE_DAYS = 'DUPLICATE_FINE_THRESHOLD_OVERDUE_DAYS',
        EXPORT_FAILED = 'EXPORT_FAILED',
        FILE_UPLOAD_ERROR = 'FILE_UPLOAD_ERROR',
        FINANCIER_INCORRECT = 'FINANCIER_INCORRECT',
        FINANCIER_NOT_FOUND = 'FINANCIER_NOT_FOUND',
        FINANCIER_DEPOSIT_NOT_FOUND = 'FINANCIER_DEPOSIT_NOT_FOUND',
        FINANCIER_DEPOSIT_NOT_EDITABLE = 'FINANCIER_DEPOSIT_NOT_EDITABLE',
        FINANCIER_PAYMENT_CHANNEL_INVALID_CONDITION = 'FINANCIER_PAYMENT_CHANNEL_INVALID_CONDITION',
        FINANCIER_PAYMENT_CHANNEL_NOT_FOUND = 'FINANCIER_PAYMENT_CHANNEL_NOT_FOUND',
        FINANCIER_SHOPS_GROUP_NOT_FOUND = 'FINANCIER_SHOPS_GROUP_NOT_FOUND',
        FINANCIER_USER_INVALID_CONDITION = 'FINANCIER_USER_INVALID_CONDITION',
        FINANCIER_SHOPS_GROUP_INSTALLMENT_CONDITION_NOT_FOUND = 'FINANCIER_SHOPS_GROUP_INSTALLMENT_CONDITION_NOT_FOUND',
        IMEI_LIST_AMOUNT_NOT_MATCH = 'IMEI_LIST_AMOUNT_NOT_MATCH',
        IMEI_LIST_EMPTY = 'IMEI_LIST_EMPTY',
        IMEI_LIST_NOT_MATCH_WITH_STOCK = 'IMEI_LIST_NOT_MATCH_WITH_STOCK',
        INCORRECT_INFORMATION = 'INCORRECT_INFORMATION',
        INSUFFICIENT_BALANCE = 'INSUFFICIENT_BALANCE',
        INSTALLMENT_COMMISSION_INCORRECT = 'INSTALLMENT_COMMISSION_INCORRECT',
        INSTALLMENT_NOTE_NOT_FOUND = 'INSTALLMENT_NOTE_NOT_FOUND',
        INSTALLMENT_PAYMENT_CANNOT_DELETE = 'INSTALLMENT_PAYMENT_CANNOT_DELETE',
        INSTALLMENT_PAYMENT_NOT_FOUND = 'INSTALLMENT_PAYMENT_NOT_FOUND',
        INSTALLMENT_PLAN_CLOSED = 'INSTALLMENT_PLAN_CLOSED',
        INSTALLMENT_PLAN_NOT_FOUND = 'INSTALLMENT_PLAN_NOT_FOUND',
        REFINANCED_INSTALLMENT_PLAN_NOT_FOUND = 'REFINANCED_INSTALLMENT_PLAN_NOT_FOUND',
        INSTALLMENT_PLAN_REFERENCE_ID_DUPLICATED = 'INSTALLMENT_PLAN_REFERENCE_ID_DUPLICATED',
        INSTALLMENT_PLAN_STATUS_MISMATCH = 'INSTALLMENT_PLAN_STATUS_MISMATCH',
        INSTALLMENT_TERM_NOT_FOUND = 'INSTALLMENT_TERM_NOT_FOUND',
        INSTALLMENT_PAYMENT_INVALID_REQUEST = 'INSTALLMENT_PAYMENT_INVALID_REQUEST',
        INVALID_GATEWAY_PAYMENT_TYPE = 'INVALID_GATEWAY_PAYMENT_TYPE',
        INVALID_GATEWAY_PAYMENT = 'INVALID_GATEWAY_PAYMENT',
        INVENTORY_NOT_ENOUGH = 'INVENTORY_NOT_ENOUGH',
        INVENTORY_NOT_FOUND = 'INVENTORY_NOT_FOUND',
        LINE_OA_CONFIG_NOT_FOUND = 'LINE_OA_CONFIG_NOT_FOUND',
        LINE_OA_INVALID_CONTACT_INFO = 'LINE_OA_INVALID_CONTACT_INFO',
        LINE_OA_LINE_API_ERROR = 'LINE_OA_LINE_API_ERROR',
        LINE_OA_PAYMENT_QR_GENERATION_ERROR = 'LINE_OA_PAYMENT_QR_GENERATION_ERROR',
        LINE_OA_RICH_MENU_NOT_SET = 'LINE_OA_RICH_MENU_NOT_SET',
        LINE_OA_UNSUPPORTED_IMAGE = 'LINE_OA_UNSUPPORTED_IMAGE',
        LOAN_INVALID_INFORMATION = 'LOAN_INVALID_INFORMATION',
        LOAN_REGISTRATION_MISSING_REQUIRED_FIELD = 'LOAN_REGISTRATION_MISSING_REQUIRED_FIELD',
        LOAN_REGISTRATION_STATUS_MISMATCH = 'LOAN_REGISTRATION_STATUS_MISMATCH',
        LOAN_STATUS_MISMATCH = 'LOAN_STATUS_MISMATCH',
        MEMBER_NOT_FOUND = 'MEMBER_NOT_FOUND',
        MISSING_REQUIRED_FIELDS = 'MISSING_REQUIRED_FIELDS',
        NUOVOPAY_API_KEY_INVALID = 'NUOVOPAY_API_KEY_INVALID',
        ORDER_NOT_FOUND = 'ORDER_NOT_FOUND',
        OWNER_TYPE_NOT_SUPPORTED = 'OWNER_TYPE_NOT_SUPPORTED',
        PAWNING_CANNOT_CALCULATE_INTEREST = 'PAWNING_CANNOT_CALCULATE_INTEREST',
        PAWNING_ID_INVALID = 'PAWNING_ID_INVALID',
        PAWNING_SIGNED_CONTRACT_NOT_FOUND = 'PAWNING_SIGNED_CONTRACT_NOT_FOUND',
        PAWNING_SLIP_AMOUNT_NOT_SUFFICIENT = 'PAWNING_SLIP_AMOUNT_NOT_SUFFICIENT',
        PAWNING_STATUS_INVALID = 'PAWNING_STATUS_INVALID',
        PAWNING_TRANSACTION_ID_INVALID = 'PAWNING_TRANSACTION_ID_INVALID',
        PAWNING_INSTALLMENT_TYPE_INVALID = 'PAWNING_INSTALLMENT_TYPE_INVALID',
        PAYMENT_NOT_FOUND = 'PAYMENT_NOT_FOUND',
        PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND',
        QR_AMOUNT_TOO_LOW = 'QR_AMOUNT_TOO_LOW',
        SERIAL_NUMBER_NOT_FOUND = 'SERIAL_NUMBER_NOT_FOUND',
        SHOP_NOT_FOUND = 'SHOP_NOT_FOUND',
        SHOP_PAYMENT_CHANNEL_INVALID_CONDITION = 'SHOP_PAYMENT_CHANNEL_INVALID_CONDITION',
        SHOP_PAYMENT_CHANNEL_NOT_FOUND = 'SHOP_PAYMENT_CHANNEL_NOT_FOUND',
        SHOP_PRODUCT_MOBILE_NOT_FOUND = 'SHOP_PRODUCT_MOBILE_NOT_FOUND',
        SHOP_PRODUCT_NOT_FOUND = 'SHOP_PRODUCT_NOT_FOUND',
        SHOP_QUOTA_ALREADY_EXISTS = 'SHOP_QUOTA_ALREADY_EXISTS',
        SHOP_QUOTA_INSUFFICIENT = 'SHOP_QUOTA_INSUFFICIENT',
        SHOP_QUOTA_INVALID_UPDATE = 'SHOP_QUOTA_INVALID_UPDATE',
        SHOP_QUOTA_NOT_FOUND = 'SHOP_QUOTA_NOT_FOUND',
        SHOP_QUOTA_VERIFY_FAILED = 'SHOP_QUOTA_VERIFY_FAILED',
        SHOP_QUOTA_DECREASE_ERROR = 'SHOP_QUOTA_DECREASE_ERROR',
        SHOP_QUOTA_RATE_NOT_FOUND = 'SHOP_QUOTA_RATE_NOT_FOUND',
        INVALID_SHOP_QUOTA_PACKAGE = 'INVALID_SHOP_QUOTA_PACKAGE',
        SHOP_REFERENCE_DUPLICATE = 'SHOP_REFERENCE_DUPLICATE',
        SHOP_SETTINGS_NOT_FOUND = 'SHOP_SETTINGS_NOT_FOUND',
        SHOP_SLIP_INTERNAL_ERROR = 'SHOP_SLIP_INTERNAL_ERROR',
        SHOP_SLIP_MISSING_INPUT = 'SHOP_SLIP_MISSING_INPUT',
        SHOP_SLIP_VERIFICATION_FAILED = 'SHOP_SLIP_VERIFICATION_FAILED',
        SHOP_USER_INVALID_CONDITION = 'SHOP_USER_INVALID_CONDITION',
        SLIP_ALREADY_EXISTS = 'SLIP_ALREADY_EXISTS',
        SLIP_INVALID_REQUEST = 'SLIP_INVALID_REQUEST',
        SLIP_NOT_EXISTS = 'SLIP_NOT_EXISTS',
        SLIP_NOT_FOUND = 'SLIP_NOT_FOUND',
        TOKEN_NOT_FOUND = 'TOKEN_NOT_FOUND',
        SUPPORT_CASE_NOT_FOUND = 'SUPPORT_CASE_NOT_FOUND',
        SUPPORT_CASE_COMMENT_NOT_FOUND = 'SUPPORT_CASE_COMMENT_NOT_FOUND',
        UNHANDLED = 'UNHANDLED',
        USER_INCORRECT = 'USER_INCORRECT',
        USER_IS_DUPLICATED = 'USER_IS_DUPLICATED',
        USER_NOT_FOUND = 'USER_NOT_FOUND',
        USER_NOT_IN_SHOP = 'USER_NOT_IN_SHOP',
        SELF_REFERRAL = 'SELF_REFERRAL',
        CIRCULAR_REFERRAL = 'CIRCULAR_REFERRAL',
        REPORT_CSV_FAILED = 'REPORT_CSV_FAILED',
        NOTIFICATION_NOT_FOUND = 'NOTIFICATION_NOT_FOUND',
        LINE_BOT_TOKEN_NOT_FOUND = 'LINE_BOT_TOKEN_NOT_FOUND',
        LINE_BOT_TOKEN_EXPIED = 'LINE_BOT_TOKEN_EXPIED',
        LINE_BOT_TOKEN_ALREADY_USED = 'LINE_BOT_TOKEN_ALREADY_USED',
        LINE_BOT_TOKEN_DISABLED = 'LINE_BOT_TOKEN_DISABLED',
        SHOP_SOURCE_NOT_FOUND = 'SHOP_SOURCE_NOT_FOUND',
        DOWN_SAVING_NOT_FOUND = 'DOWN_SAVING_NOT_FOUND',
        DOWN_SAVING_AMOUNT_LESS_THAN_SAVING_AMOUNT = 'DOWN_SAVING_AMOUNT_LESS_THAN_SAVING_AMOUNT',
        DOWN_SAVING_NOT_ACTIVE = 'DOWN_SAVING_NOT_ACTIVE',
        DOWN_SAVING_AMOUNT_GREATER_THAN_BALANCE = 'DOWN_SAVING_AMOUNT_GREATER_THAN_BALANCE',
        DOWN_SAVING_TRANSACTION_NOT_FOUND = 'DOWN_SAVING_TRANSACTION_NOT_FOUND',
        DOWN_SAVING_TRANSACTION_ALREADY_DELETED = 'DOWN_SAVING_TRANSACTION_ALREADY_DELETED',
        DOWN_SAVING_AMOUNT_LESS_THAN_MINIMUM_PAYMENT = 'DOWN_SAVING_AMOUNT_LESS_THAN_MINIMUM_PAYMENT',
        CLAIM_NOT_FOUND = 'CLAIM_NOT_FOUND',
        CLAIM_CENTRAL_NOT_FOUND = 'CLAIM_CENTRAL_NOT_FOUND',
        CLAIM_INVOICE_NOT_FOUND = 'CLAIM_INVOICE_NOT_FOUND',
        CLAIM_IMAGE_NOT_FOUND = 'CLAIM_IMAGE_NOT_FOUND',
        DIVIDE_BY_ZERO = 'DIVIDE_BY_ZERO',
        INVALID_REQUEST = 'INVALID_REQUEST',
        UNAUTHORIZED = 'UNAUTHORIZED',
        PROFILE_NOT_FOUND = 'PROFILE_NOT_FOUND',
        CLAIM_FAILED = 'CLAIM_FAILED',
        GET_CLAIM_PRODUCT_TRANSACTION_FAILED = 'GET_CLAIM_PRODUCT_TRANSACTION_FAILED',
        INSTALLMENT_PLAN_CANCEL_NOT_SAME_DAY = 'INSTALLMENT_PLAN_CANCEL_NOT_SAME_DAY',
        INSTALLMENT_PLAN_CANCEL_AFTER_APPROVAL = 'INSTALLMENT_PLAN_CANCEL_AFTER_APPROVAL',
        FAILED_CANCEL_INSTALLMENT_PLAN = 'FAILED_CANCEL_INSTALLMENT_PLAN',
        INSTALLMENT_PLAN_CANCEL_NOT_COMPLETED = 'INSTALLMENT_PLAN_CANCEL_NOT_COMPLETED',
        FINANCIER_USER_ALREADY_EXISTS = 'FINANCIER_USER_ALREADY_EXISTS',
    }
}

